import locale from "localization";
import styles from "./customer-list-column.module.scss";

export const customerColumns = [
  {
    key: "fullName",
    text: (
      <span className={styles.heading}>
        {locale.firstName}/ {locale.lastName}
      </span>
    ),
    width: "2%",
  },
  {
    key: "contact",
    text: (
      <span className={styles.heading}>
        {locale.mobileNumber}/{locale.email}/{locale.userId}
      </span>
    ),
    width: "3%",
  },
  {
    key: "station",
    text: <span className={styles.heading}>{locale.referenceStatonSelected}</span>,
    width: "15%",
  },
  {
    key: "referral",
    text: <span className={styles.heading}>{locale.uniqueReferalCode}</span>,
    width: "8%",
  },
  {
    key: "registered",
    text: <span className={styles.heading}>{locale.dateRegistered}</span>,
    width: "15%",
  },
  {
    key: "walletBalance",
    text: <span className={styles.heading}>{locale.pesoBalance}</span>,
    width: "5%",
  },
  {
    key: "product",
    text: <span className={styles.heading}>{locale.product}</span>,
    width: "300px",
  },

  {
    key: "literBalance",
    text: <span className={styles.heading}>{locale.literBalance}</span>,
    width: "10%",
  },

  {
    key: "status",
    text: (
      <span className={styles.heading}>
        {locale.status}/ {locale.dateOfLastUpdate}
      </span>
    ),
    width: "15%",
  },
  { key: "remarks", text: locale.remarks },
  {
    key: "accountType",
    text: <span className={styles.heading}>{locale.accountType}</span>,
    width: "15%",
  },

  {
    key: "action",
    text: <span className={styles.heading}>{locale.action}</span>,
    width: "3%",
  },
];
